import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { StudiesService } from '../studies.service';
import { TranslateService } from '@ngx-translate/core';
import { UsersService } from 'src/app/users/users.service';
import { SitesService } from 'src/app/sites/sites.service';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
	selector: 'app-manage-study',
	templateUrl: './manage-study.component.html',
	styleUrls: ['./manage-study.component.css']
})
export class ManageStudyComponent  implements OnInit, AfterViewInit {
	@Input() manageStudyData: any = null;

	@Output() onClose = new EventEmitter<{status: boolean, site_id?: number, customer_id?: number}>();
	
	@ViewChild('manageStudyModal') manageStudyModal: ModalComponent;

	customers: any[] = [];
	sites: any[] = [];

	selectedCustomerId: any = '';
	selectedSiteId: any = '';

	formError: string | null = null;
	successMessage = '';

	constructor(
		private studiesService: StudiesService,
		private translateService: TranslateService,
		public usersService: UsersService,
		private sitesService: SitesService,
		private commonService: CommonService
	) {}

	ngOnInit() {
		this.sitesService.getUserSitesInfo({ get_customers: true }).subscribe((data: any) => {
			this.customers = data.customers.sort((a, b) =>
				a.customer_name.toLowerCase() > b.customer_name.toLowerCase() ? 1 : -1
			);

			if (this.manageStudyData?.customer_id) {
				this.selectedCustomerId = this.manageStudyData.customer_id;
				this.loadSitesForCustomer(this.selectedCustomerId);
			}

			if (this.manageStudyData?.site_id)
				this.selectedSiteId = this.manageStudyData.site_id;
		});
	}

	ngAfterViewInit() {
		this.manageStudyModal.show();
		this.manageStudyModal.onClose.subscribe(() => {
			this.onClose.emit({ status: false });
			this.manageStudyModal.hide();
		});
	}

	onCustomerChange(customerId: any) {
		this.selectedSiteId = null;
		this.loadSitesForCustomer(customerId);
	}

	loadSitesForCustomer(customerId: any) {
		this.sites = [];
		const customer = this.customers.find(c => c.id == customerId);
		if (customer)
			this.sites = customer.sites.filter(s => s.name != this.commonService.powerStudiesDevicesSiteName).sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
	}

	submit() {
		this.formError = null;

		if (!this.selectedCustomerId || !this.selectedSiteId) {
			this.formError = this.translateService.instant('g.invalid_input');
			return;
		}

		const body = {
			study_id: this.manageStudyData.id,
			customer_id: this.selectedCustomerId,
			site_id: this.selectedSiteId,
		};

		this.studiesService.editStudy(body).subscribe((res: any) => {
			if (res.api_status > 1) {
				this.formError = this.translateService.instant('g.failed');
				return;
			}
			this.successMessage = this.translateService.instant('studies.operation_done_successfully');
		});
	}

	closeSuccess() {
		this.onClose.emit({status: true, site_id: this.selectedSiteId, customer_id: this.selectedCustomerId});
		this.manageStudyModal.hide();
	}

	cancel() {
		this.onClose.emit({status: false});
		this.manageStudyModal.hide();
	}
}
